var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        persistent: "",
        "hide-overlay": "",
        transition: "dialog-bottom-transition",
        width: _vm.$vuetify.breakpoint.smAndDown ? "100vw" : "65vw",
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-toolbar",
            { attrs: { dark: "", color: "primary" } },
            [
              _c(
                "v-btn",
                {
                  attrs: { icon: "", dark: "" },
                  on: {
                    click: function ($event) {
                      return _vm.Close()
                    },
                  },
                },
                [_c("v-icon", [_vm._v("mdi-close")])],
                1
              ),
              _c("v-toolbar-title", [_vm._v("Cadastro Item Rubrica")]),
              _c("v-spacer"),
              _c(
                "v-toolbar-items",
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { dark: "", text: "", disabled: !_vm.valid },
                      on: {
                        click: function ($event) {
                          return _vm.Salvar()
                        },
                      },
                    },
                    [_vm._v("Salvar")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-form",
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              model: {
                value: _vm.valid,
                callback: function ($$v) {
                  _vm.valid = $$v
                },
                expression: "valid",
              },
            },
            [
              _c(
                "v-card-text",
                { staticClass: "mt-3" },
                [
                  _c(
                    "v-row",
                    { attrs: { dense: "" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "12", md: "12" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Descrição",
                              counter: 255,
                              maxlength: "255",
                              rules: _vm.fieldRules,
                              dense: "",
                              outlined: "",
                            },
                            model: {
                              value: _vm.item.descricao,
                              callback: function ($$v) {
                                _vm.$set(_vm.item, "descricao", $$v)
                              },
                              expression: "item.descricao",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "12", md: "6" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              label: "Natureza",
                              "item-value": "id",
                              "item-text": "nome",
                              items: _vm.naturezas,
                              rules: _vm.fieldRules,
                              dense: "",
                              outlined: "",
                            },
                            model: {
                              value: _vm.item.naturezaId,
                              callback: function ($$v) {
                                _vm.$set(_vm.item, "naturezaId", $$v)
                              },
                              expression: "item.naturezaId",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "12", md: "6" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              type: "number",
                              label: "Total Estimado",
                              rules: _vm.fieldRules,
                              dense: "",
                              outlined: "",
                            },
                            model: {
                              value: _vm.item.totalEstimado,
                              callback: function ($$v) {
                                _vm.$set(_vm.item, "totalEstimado", _vm._n($$v))
                              },
                              expression: "item.totalEstimado",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "6", md: "6" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              type: "date",
                              label: "Data Inicio",
                              rules: _vm.fieldRules,
                              dense: "",
                              outlined: "",
                            },
                            model: {
                              value: _vm.item.dataInicio,
                              callback: function ($$v) {
                                _vm.$set(_vm.item, "dataInicio", $$v)
                              },
                              expression: "item.dataInicio",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "6", md: "6" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              type: "date",
                              label: "Data Fim",
                              rules: _vm.fieldRules,
                              dense: "",
                              outlined: "",
                            },
                            model: {
                              value: _vm.item.dataTermino,
                              callback: function ($$v) {
                                _vm.$set(_vm.item, "dataTermino", $$v)
                              },
                              expression: "item.dataTermino",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }